<!--  -->
<template>
    <div class="box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/', query: {tab: 0} }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/jiancenengli' }">检测能力</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
  
      <div class="content">
          <div class="title">{{ info.name }}</div>
  
          <img :src="downloadUrl + info.photo" alt="" class="img">
  
          <div class="duration" v-html="info.synopsis"></div>
      </div>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  export default {
    data () {
      return {
          id: '', // 文章id
          info: {}, 
          downloadUrl: '',
      }
    },
    created() {
      this.downloadUrl = this.$downloadUrl
      console.log(this.$route.query.id);
      this.id = this.$route.query.id
      this.getData()
    },
    methods: {
      getData() {
          Server.getJianyanjianceInfo({id: this.id}).then(res => {
              console.log(res);
              if(res.success) {
                  this.info = res.result.records[0]
              }
          })
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
      .content {
          margin: 20px 0 50px;
          background-color: #fff;
          padding: 50px ;
          box-sizing: border-box;
  
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
              font-size: 24px;
              font-weight: bold;
              
          }
          .img {
              margin: 50px 0;
              max-width: 100%;
          }
          .duration {
              line-height: 35px;
              text-indent: 0.5em;
          }
      }
  </style>
  